import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  NavigationExtras,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { DataService } from '../data.service';
//import { AuthService } from './auth.service';

@Injectable()
export class AuthenticationGuard implements CanActivate {
  loggedIn = false;
  constructor(private router: Router, 
    //private authService: AuthService
    ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
  
    if(sessionStorage.getItem('id_token')){
      this.loggedIn = true;
    }
    else{
      this.loggedIn = false;
    }
      if(this.loggedIn)
      {
        
        return this.loggedIn
      }
    this.router.navigate([''], { queryParams: { returnUrl: state.url } });
    return false;
  }
}
